import { NextSeo } from "next-seo";
import Link from "next/link";
import { useRouter } from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import Public from "../Layouts/Public";
import PageSection, { StyledSectionHeading } from "../components/PageSection";
import { siteTitle } from "../data/PublicSiteData";
import { trackPageView } from "../includes/analytics";
import { Color } from "../theme/Color";

const PhotoCredits = () => {
  const router = useRouter();

  trackPageView("/photo-credits");

  return (
    <>
      <NextSeo
        title={`Photo Credits | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to interact online.
Get inspiration, local knowledge, advice & deals directly from any destination."
      />
      <PageSection
        backgroundColor={Color.White}
        width="1340px"
        data-cy="core-values"
      >
        <StyledSectionHeading center="xs">Photo Credits</StyledSectionHeading>
        <Row center="xs" middle="xs">
          <Col
            xs={10}
            md={8}
            style={{ color: Color.Grey2, marginBottom: "5rem" }}
          >
            <ul>
              <li>Home page: Cliffs of Moher, WeLoveIreland, Instagram</li>
              <li>Travelers /&nbsp;Solo trip: Beach</li>
              <li>
                Travelers / Group trip: Vr&#39;s, Canva Pro, FS-Stock-Getty
              </li>
              <li>
                Travelers / Group trip: Cycling, Canva Pro, Duncan-Andison
              </li>
              <li>Travelers / Club Trip:&nbsp; Diving photo</li>
              <li>Travelers / Club Trip:&nbsp; Hiking photo, Canva pro</li>
              <li>Destinations: Hiking, Unsplash, Nika Tchokehone</li>
              <li>Destinations: Boat on Sea, Unsplash, Chase Baker</li>
              <li>About: Hidden Trail,&nbsp; Canva Pro, Diana_OCarroll</li>
              <li>Ameegos: Climbers, Canva, Kieferapix</li>
              <li>Ameegos: Hostel, Pexels, Cottonbro Studio</li>
              <li>
                Business / Accommodation: Bed on the cliff, Pexels, Patrick
                Robert Doyle
              </li>
              <li>Business / Accommodation: Bed and breakfast, Canva Pro</li>
              <li>Business / Attractions: Horseriding, Unsplash</li>
              <li>Business / Attractions: Paris, Pexels, Alex Azabache</li>
              <li>
                Business / Food and Drink: Retro pub, Canva Pro, Niodrag
                Ignjatovic
              </li>
              <li>
                Business / Food and Drink: Pub food, Canva Pro, Brent Randall
              </li>
              <li>
                Business / Entertainment: Canva Pro, Mach&eacute; Charpantie
              </li>
              <li>
                Business / Entertainment: Tig C&oacute;il&iacute; Pub, Irelands
                Content Pool, @failteireland, SanderVisuals
              </li>
              <li>Business / Transport: Train, Canva Pro, 12019, Pixabay</li>
              <li>Business / Transport: Bus, Canva Pro, mladnbl</li>
              <li>Business / Tours: Camel Ride, iStockPhoto</li>
              <li>Business / Tours: Walking tour, Canva Pro</li>
            </ul>
            <p>
              "Ameego Recruitment & Promotion" online campaigns - Images from
              Irelands Content pool. Individual images can be specifically
              credited by contacting us at{" "}
              <Link href="mailto:info@valmeego.com">info@valmeego.com</Link>.
            </p>
          </Col>
        </Row>
      </PageSection>
    </>
  );
};

PhotoCredits.Layout = Public;

export default PhotoCredits;
